/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Interface, type ContractRunner } from "ethers";
import type { TreasuryLib, TreasuryLibInterface } from "../TreasuryLib";

const _abi = [
  {
    inputs: [],
    name: "AUGMENT_GOV_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "REPAIR_GOV_FEE",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
] as const;

export class TreasuryLib__factory {
  static readonly abi = _abi;
  static createInterface(): TreasuryLibInterface {
    return new Interface(_abi) as TreasuryLibInterface;
  }
  static connect(address: string, runner?: ContractRunner | null): TreasuryLib {
    return new Contract(address, _abi, runner) as unknown as TreasuryLib;
  }
}
